"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = exports.SubscriptionType = exports.UserRole = void 0;
/** Rolle eines Nutzers innerhalb seiner Organisation. Geteilt über alle Apps. */
var UserRole;
(function (UserRole) {
    UserRole["Driver"] = "driver";
    UserRole["CompanyAdmin"] = "company_admin";
    UserRole["Admin"] = "admin";
})(UserRole || (exports.UserRole = UserRole = {}));
/** Abo-Stufe eines Nutzers. Geteilt über alle Apps. */
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Free"] = "free";
    SubscriptionType["Pro"] = "pro";
})(SubscriptionType || (exports.SubscriptionType = SubscriptionType = {}));
/**
 * Derived display status of a user in the customer admin portal, based on
 * days since last login (best → worst):
 *
 *   VERY_ACTIVE          – logged in within the last 21 days.
 *   ACTIVE               – logged in 22-45 days ago.
 *   REACTIVATION_NEEDED  – no login in 46+ days, or never logged in.
 *   DEACTIVATED          – `isActive=false`. Set by an admin; blocks
 *                           authentication; takes priority over login
 *                           recency.
 *
 * Purely derived for display; never persisted. See backend `computeUserStatus`.
 */
var UserStatus;
(function (UserStatus) {
    UserStatus["VERY_ACTIVE"] = "VERY_ACTIVE";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["REACTIVATION_NEEDED"] = "REACTIVATION_NEEDED";
    UserStatus["DEACTIVATED"] = "DEACTIVATED";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
//# sourceMappingURL=user.js.map